export default __webpack_public_path__ + "static/media/wifi-1.a98137ff.svg";